import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import Input from '../../components/form/input';
import RemoteCommandBar from './remoteCommandBar';

@observer
class ShotTrainerFieldRemote extends Component {
    updateFirebaseRemoteSessionId = (e) => {
        const { value } = e.target;
        const { shotTrainerStore } = this.props.stores;
        shotTrainerStore.updateKeyValue('firebaseRemoteSessionId', value);
    }

    clearFirebaseRemoteSessionId = () => {
        const { shotTrainerStore } = this.props.stores;
        shotTrainerStore.updateKeyValue('firebaseRemoteSessionId', null);
    }

    render() {
        const { classNames = '' } = this.props;
        const { userStore, shotTrainerStore } = this.props.stores;
        const { user = {} } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        const { firebaseRemoteSessionId } = shotTrainerStore;

        return (
            <div class={`w-100 d-flex flex-column justify-content-center ${classNames} mb-3 mt-3`}>
                <div class='font-weight-lighter px-3 box-header text-danger'>
                    <Text id='shottrainer.field-remote-title'>Field shooting remote</Text>
                </div>
                <div class={`d-flex flex-column mx-3 px-3 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} border border-danger shadow`}>
                    <div class='d-flex flex-row flex-fill'>
                        <Input
                            stores={this.props.stores}
                            holdingStore={shotTrainerStore}
                            object={{}}
                            type='tel'
                            pattern='[0-9]*'
                            inputmode='numeric'
                            class='form-control'
                            field='firebaseRemoteSessionId'
                            placeholder={`Firebase session id`}
                            onInput={e => this.updateFirebaseRemoteSessionId(e)}
                            inputValue={firebaseRemoteSessionId}
                        />
                        {!!firebaseRemoteSessionId && (
                            <button
                                type='button'
                                class='btn btn-lg btn-outline-danger rounded-pill ms-2 text-nowrap'
                                onClick={this.clearFirebaseRemoteSessionId}
                            >
                                <i class='fa-duotone fa-trash me-2' />
                                <Text id='shottrainer.remove-remote-id'>Remove</Text>
                            </button>
                        )}
                    </div>

                    <RemoteCommandBar stores={this.props.stores} />
                </div>
            </div>
        );
    }
}

export default ShotTrainerFieldRemote;
